import { useQueryClient, VueQueryPlugin } from '@tanstack/vue-query';
import { getCurrentInstance } from 'vue';

export const checkQueryClient = () => {
    try {
        // Attempt to get the queryClient
        useQueryClient();
    } catch (error) {
        // QueryClient not initialized, so initialize it now
        console.debug('QueryClient not initialized. Initializing now.');

        const app = getCurrentInstance()?.appContext.app;

        if (app) {
            app.use(VueQueryPlugin);
            const queryClient = useQueryClient();
            console.debug('QueryClient loaded:', !!queryClient);
        } else {
            console.error('Unable to access app instance. QueryClient initialization failed.');
        }
    }
};
